/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const authenticatedImageUrl = /* GraphQL */ `
  query AuthenticatedImageUrl($url: String, $token: String) {
    authenticatedImageUrl(url: $url, token: $token) {
      statusCode
      body
    }
  }
`;
export const listDomains = /* GraphQL */ `
  query ListDomains($token: String, $provider: String) {
    listDomains(token: $token, provider: $provider) {
      statusCode
      body {
        domain_id_str
        domain_name
        frozen
        updated_at
        role {
          role_id
          type
          name
        }
        contract {
          solution_ids
          direct_app_keys
        }
        setting {
          allow_attachment_type
          allow_save_attachments {
            web
            ios
            android
            desktop
          }
          allow_take_screenshot
        }
      }
    }
  }
`;
export const attachmentPushUrl = /* GraphQL */ `
  query AttachmentPushUrl($objectKey: String) {
    attachmentPushUrl(objectKey: $objectKey) {
      statusCode
      body
    }
  }
`;
export const getTopic = /* GraphQL */ `
  query GetTopic($domainId: String!, $id: ID!) {
    getTopic(domainId: $domainId, id: $id) {
      id
      domainId
      title
      desc
      icon {
        url
        mime
      }
      pinned
      categoryId
      messages
      owner
      updatedAt
      createdAt
      deleted
      deletedUser
      acl {
        id
        refId
        refIdType
        base {
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
        guest {
          id
          refId
          refIdType
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
        items {
          id
          refId
          refIdType
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
      }
      notification
    }
  }
`;
export const listTopics = /* GraphQL */ `
  query ListTopics(
    $domainId: String
    $id: ModelIDKeyConditionInput
    $filter: ModelTopicFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listTopics(
      domainId: $domainId
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        domainId
        title
        desc
        icon {
          url
          mime
        }
        pinned
        categoryId
        messages
        owner
        updatedAt
        createdAt
        deleted
        deletedUser
        acl {
          id
          refId
          refIdType
          base {
            create
            read
            update
            delete
            createTopic
            createMessage
            createComment
            createReactions
          }
          guest {
            id
            refId
            refIdType
            create
            read
            update
            delete
            createTopic
            createMessage
            createComment
            createReactions
          }
          items {
            id
            refId
            refIdType
            create
            read
            update
            delete
            createTopic
            createMessage
            createComment
            createReactions
          }
        }
        notification
      }
      nextToken
    }
  }
`;
export const getMessage = /* GraphQL */ `
  query GetMessage($topicId: String!, $id: ID!) {
    getMessage(topicId: $topicId, id: $id) {
      id
      domainId
      topicId
      title
      message
      pinned
      owner
      commentId
      photos {
        url
        mime
      }
      updatedAt
      createdAt
      deleted
      deletedUser
      acl {
        id
        refId
        refIdType
        base {
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
        guest {
          id
          refId
          refIdType
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
        items {
          id
          refId
          refIdType
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
      }
    }
  }
`;
export const listMessages = /* GraphQL */ `
  query ListMessages(
    $topicId: String
    $id: ModelIDKeyConditionInput
    $filter: ModelMessageFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listMessages(
      topicId: $topicId
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        domainId
        topicId
        title
        message
        pinned
        owner
        commentId
        photos {
          url
          mime
        }
        updatedAt
        createdAt
        deleted
        deletedUser
        acl {
          id
          refId
          refIdType
          base {
            create
            read
            update
            delete
            createTopic
            createMessage
            createComment
            createReactions
          }
          guest {
            id
            refId
            refIdType
            create
            read
            update
            delete
            createTopic
            createMessage
            createComment
            createReactions
          }
          items {
            id
            refId
            refIdType
            create
            read
            update
            delete
            createTopic
            createMessage
            createComment
            createReactions
          }
        }
      }
      nextToken
    }
  }
`;
export const getComment = /* GraphQL */ `
  query GetComment($messageId: String!, $id: ID!) {
    getComment(messageId: $messageId, id: $id) {
      id
      domainId
      topicId
      messageId
      message
      photos {
        url
        mime
      }
      owner
      updatedAt
      createdAt
      deleted
      deletedUser
      acl {
        id
        refId
        refIdType
        base {
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
        guest {
          id
          refId
          refIdType
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
        items {
          id
          refId
          refIdType
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
      }
    }
  }
`;
export const listComments = /* GraphQL */ `
  query ListComments(
    $messageId: String
    $id: ModelIDKeyConditionInput
    $filter: ModelCommentFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listComments(
      messageId: $messageId
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        domainId
        topicId
        messageId
        message
        photos {
          url
          mime
        }
        owner
        updatedAt
        createdAt
        deleted
        deletedUser
        acl {
          id
          refId
          refIdType
          base {
            create
            read
            update
            delete
            createTopic
            createMessage
            createComment
            createReactions
          }
          guest {
            id
            refId
            refIdType
            create
            read
            update
            delete
            createTopic
            createMessage
            createComment
            createReactions
          }
          items {
            id
            refId
            refIdType
            create
            read
            update
            delete
            createTopic
            createMessage
            createComment
            createReactions
          }
        }
      }
      nextToken
    }
  }
`;
export const getCategory = /* GraphQL */ `
  query GetCategory($domainId: String!, $id: ID!) {
    getCategory(domainId: $domainId, id: $id) {
      id
      title
      domainId
      color
      owner
      updatedAt
      createdAt
      deleted
      deletedUser
    }
  }
`;
export const listCategories = /* GraphQL */ `
  query ListCategories(
    $domainId: String
    $id: ModelIDKeyConditionInput
    $filter: ModelCategoryFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listCategories(
      domainId: $domainId
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        title
        domainId
        color
        owner
        updatedAt
        createdAt
        deleted
        deletedUser
      }
      nextToken
    }
  }
`;
export const getUser = /* GraphQL */ `
  query GetUser($directId: String!) {
    getUser(directId: $directId) {
      id
      directId
      name
      profileIcon
      domainIdList
      owner
      favorites
      likes
      updatedAt
      createdAt
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $directId: String
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listUsers(
      directId: $directId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        directId
        name
        profileIcon
        domainIdList
        owner
        favorites
        likes
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const getDomainUser = /* GraphQL */ `
  query GetDomainUser($domainId: String!, $userDirectId: String!) {
    getDomainUser(domainId: $domainId, userDirectId: $userDirectId) {
      domainId
      userDirectId
      user {
        id
        directId
        name
        profileIcon
        domainIdList
        owner
        favorites
        likes
        updatedAt
        createdAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listDomainUsers = /* GraphQL */ `
  query ListDomainUsers(
    $domainId: String
    $userDirectId: ModelStringKeyConditionInput
    $filter: ModelDomainUserFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listDomainUsers(
      domainId: $domainId
      userDirectId: $userDirectId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        domainId
        userDirectId
        user {
          id
          directId
          name
          profileIcon
          domainIdList
          owner
          favorites
          likes
          updatedAt
          createdAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getDepartment = /* GraphQL */ `
  query GetDepartment($domainId: String!, $user_defined_key: String!) {
    getDepartment(domainId: $domainId, user_defined_key: $user_defined_key) {
      domainId
      department_id
      name
      user_defined_key
      order
      parent
      node
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listDepartments = /* GraphQL */ `
  query ListDepartments(
    $domainId: String
    $user_defined_key: ModelStringKeyConditionInput
    $filter: ModelDepartmentFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listDepartments(
      domainId: $domainId
      user_defined_key: $user_defined_key
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        domainId
        department_id
        name
        user_defined_key
        order
        parent
        node
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getNotifications = /* GraphQL */ `
  query GetNotifications($id: ID!) {
    getNotifications(id: $id) {
      id
      domainId
      title
      desc
      users
      departments
      exclude_users
      exclude_departments
      createdAt
      updatedAt
    }
  }
`;
export const listNotifications = /* GraphQL */ `
  query ListNotifications(
    $filter: ModelNotificationsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNotifications(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        domainId
        title
        desc
        users
        departments
        exclude_users
        exclude_departments
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getIconReaction = /* GraphQL */ `
  query GetIconReaction(
    $type: IconReactionType!
    $targetType: ReactionTargetType!
    $domainId: String!
    $topicId: String!
    $messageId: String!
    $commentId: String!
  ) {
    getIconReaction(
      type: $type
      targetType: $targetType
      domainId: $domainId
      topicId: $topicId
      messageId: $messageId
      commentId: $commentId
    ) {
      type
      targetType
      domainId
      topicId
      messageId
      commentId
      userIdList
      createdAt
      updatedAt
    }
  }
`;
export const listIconReactions = /* GraphQL */ `
  query ListIconReactions(
    $type: IconReactionType
    $targetTypeDomainIdTopicIdMessageIdCommentId: ModelIconReactionPrimaryCompositeKeyConditionInput
    $filter: ModelIconReactionFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listIconReactions(
      type: $type
      targetTypeDomainIdTopicIdMessageIdCommentId: $targetTypeDomainIdTopicIdMessageIdCommentId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        type
        targetType
        domainId
        topicId
        messageId
        commentId
        userIdList
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getDomainSettings = /* GraphQL */ `
  query GetDomainSettings($id: ID!) {
    getDomainSettings(id: $id) {
      id
      createTopicAuthorityGroupPolicy {
        admin
        user
      }
      updateTopicAuthorityGroupPolicy {
        admin
        user
      }
      attachmentPolicy
      attachmentFileType {
        image
        movie
        pdf
        office
      }
      downloadPolicy
      downloadDeviceType {
        web
        ios
        android
        desktop
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listDomainSettings = /* GraphQL */ `
  query ListDomainSettings(
    $filter: ModelDomainSettingsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDomainSettings(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        createTopicAuthorityGroupPolicy {
          admin
          user
        }
        updateTopicAuthorityGroupPolicy {
          admin
          user
        }
        attachmentPolicy
        attachmentFileType {
          image
          movie
          pdf
          office
        }
        downloadPolicy
        downloadDeviceType {
          web
          ios
          android
          desktop
        }
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getAllowFeature = /* GraphQL */ `
  query GetAllowFeature($keyword: String!) {
    getAllowFeature(keyword: $keyword) {
      keyword
      releasePhase
      desc
      updatedAt
      createdAt
    }
  }
`;
export const listAllowFeatures = /* GraphQL */ `
  query ListAllowFeatures(
    $keyword: String
    $filter: ModelAllowFeatureFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listAllowFeatures(
      keyword: $keyword
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        keyword
        releasePhase
        desc
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const listTopicsByDomainId = /* GraphQL */ `
  query ListTopicsByDomainId(
    $domainId: String
    $sortDirection: ModelSortDirection
    $filter: ModelTopicFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ListTopicsByDomainId(
      domainId: $domainId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        domainId
        title
        desc
        icon {
          url
          mime
        }
        pinned
        categoryId
        messages
        owner
        updatedAt
        createdAt
        deleted
        deletedUser
        acl {
          id
          refId
          refIdType
          base {
            create
            read
            update
            delete
            createTopic
            createMessage
            createComment
            createReactions
          }
          guest {
            id
            refId
            refIdType
            create
            read
            update
            delete
            createTopic
            createMessage
            createComment
            createReactions
          }
          items {
            id
            refId
            refIdType
            create
            read
            update
            delete
            createTopic
            createMessage
            createComment
            createReactions
          }
        }
        notification
      }
      nextToken
    }
  }
`;
export const listMessagesByDomainAndTopic = /* GraphQL */ `
  query ListMessagesByDomainAndTopic(
    $domainId: String
    $topicId: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ListMessagesByDomainAndTopic(
      domainId: $domainId
      topicId: $topicId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        domainId
        topicId
        title
        message
        pinned
        owner
        commentId
        photos {
          url
          mime
        }
        updatedAt
        createdAt
        deleted
        deletedUser
        acl {
          id
          refId
          refIdType
          base {
            create
            read
            update
            delete
            createTopic
            createMessage
            createComment
            createReactions
          }
          guest {
            id
            refId
            refIdType
            create
            read
            update
            delete
            createTopic
            createMessage
            createComment
            createReactions
          }
          items {
            id
            refId
            refIdType
            create
            read
            update
            delete
            createTopic
            createMessage
            createComment
            createReactions
          }
        }
      }
      nextToken
    }
  }
`;
export const listMessagesByUpdatedAt = /* GraphQL */ `
  query ListMessagesByUpdatedAt(
    $topicId: String
    $updatedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ListMessagesByUpdatedAt(
      topicId: $topicId
      updatedAt: $updatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        domainId
        topicId
        title
        message
        pinned
        owner
        commentId
        photos {
          url
          mime
        }
        updatedAt
        createdAt
        deleted
        deletedUser
        acl {
          id
          refId
          refIdType
          base {
            create
            read
            update
            delete
            createTopic
            createMessage
            createComment
            createReactions
          }
          guest {
            id
            refId
            refIdType
            create
            read
            update
            delete
            createTopic
            createMessage
            createComment
            createReactions
          }
          items {
            id
            refId
            refIdType
            create
            read
            update
            delete
            createTopic
            createMessage
            createComment
            createReactions
          }
        }
      }
      nextToken
    }
  }
`;
export const listCommentsByTopicId = /* GraphQL */ `
  query ListCommentsByTopicId(
    $topicId: String
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCommentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ListCommentsByTopicId(
      topicId: $topicId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        domainId
        topicId
        messageId
        message
        photos {
          url
          mime
        }
        owner
        updatedAt
        createdAt
        deleted
        deletedUser
        acl {
          id
          refId
          refIdType
          base {
            create
            read
            update
            delete
            createTopic
            createMessage
            createComment
            createReactions
          }
          guest {
            id
            refId
            refIdType
            create
            read
            update
            delete
            createTopic
            createMessage
            createComment
            createReactions
          }
          items {
            id
            refId
            refIdType
            create
            read
            update
            delete
            createTopic
            createMessage
            createComment
            createReactions
          }
        }
      }
      nextToken
    }
  }
`;
export const listCommentsByMessageId = /* GraphQL */ `
  query ListCommentsByMessageId(
    $topicId: String
    $messageIdCreatedAt: ModelCommentListCommentsByMessageIdCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCommentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ListCommentsByMessageId(
      topicId: $topicId
      messageIdCreatedAt: $messageIdCreatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        domainId
        topicId
        messageId
        message
        photos {
          url
          mime
        }
        owner
        updatedAt
        createdAt
        deleted
        deletedUser
        acl {
          id
          refId
          refIdType
          base {
            create
            read
            update
            delete
            createTopic
            createMessage
            createComment
            createReactions
          }
          guest {
            id
            refId
            refIdType
            create
            read
            update
            delete
            createTopic
            createMessage
            createComment
            createReactions
          }
          items {
            id
            refId
            refIdType
            create
            read
            update
            delete
            createTopic
            createMessage
            createComment
            createReactions
          }
        }
      }
      nextToken
    }
  }
`;
export const categoryByDomainId = /* GraphQL */ `
  query CategoryByDomainId(
    $domainId: String
    $title: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    CategoryByDomainId(
      domainId: $domainId
      title: $title
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        domainId
        color
        owner
        updatedAt
        createdAt
        deleted
        deletedUser
      }
      nextToken
    }
  }
`;
export const userByCognitoUserId = /* GraphQL */ `
  query UserByCognitoUserId(
    $id: ID
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    UserByCognitoUserId(
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        directId
        name
        profileIcon
        domainIdList
        owner
        favorites
        likes
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const domainUsersByDomainId = /* GraphQL */ `
  query DomainUsersByDomainId(
    $domainId: String
    $sortDirection: ModelSortDirection
    $filter: ModelDomainUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    DomainUsersByDomainId(
      domainId: $domainId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        domainId
        userDirectId
        user {
          id
          directId
          name
          profileIcon
          domainIdList
          owner
          favorites
          likes
          updatedAt
          createdAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const departmentByOrder = /* GraphQL */ `
  query DepartmentByOrder(
    $domainId: String
    $order: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDepartmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    DepartmentByOrder(
      domainId: $domainId
      order: $order
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        domainId
        department_id
        name
        user_defined_key
        order
        parent
        node
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const listIconReactionByDomainId = /* GraphQL */ `
  query ListIconReactionByDomainId(
    $type: IconReactionType
    $targetTypeDomainId: ModelIconReactionListIconReactionByDomaniIdCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelIconReactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ListIconReactionByDomainId(
      type: $type
      targetTypeDomainId: $targetTypeDomainId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        type
        targetType
        domainId
        topicId
        messageId
        commentId
        userIdList
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listIconReactionByTopicId = /* GraphQL */ `
  query ListIconReactionByTopicId(
    $type: IconReactionType
    $targetTypeDomainIdTopicId: ModelIconReactionListIconReactionByTopicIdCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelIconReactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ListIconReactionByTopicId(
      type: $type
      targetTypeDomainIdTopicId: $targetTypeDomainIdTopicId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        type
        targetType
        domainId
        topicId
        messageId
        commentId
        userIdList
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listReactionsByTopicId = /* GraphQL */ `
  query ListReactionsByTopicId(
    $topicId: String
    $type: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelIconReactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ListReactionsByTopicId(
      topicId: $topicId
      type: $type
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        type
        targetType
        domainId
        topicId
        messageId
        commentId
        userIdList
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const searchTopics = /* GraphQL */ `
  query SearchTopics(
    $filter: SearchableTopicFilterInput
    $sort: SearchableTopicSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchTopics(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        domainId
        title
        desc
        icon {
          url
          mime
        }
        pinned
        categoryId
        messages
        owner
        updatedAt
        createdAt
        deleted
        deletedUser
        acl {
          id
          refId
          refIdType
          base {
            create
            read
            update
            delete
            createTopic
            createMessage
            createComment
            createReactions
          }
          guest {
            id
            refId
            refIdType
            create
            read
            update
            delete
            createTopic
            createMessage
            createComment
            createReactions
          }
          items {
            id
            refId
            refIdType
            create
            read
            update
            delete
            createTopic
            createMessage
            createComment
            createReactions
          }
        }
        notification
      }
      nextToken
      total
    }
  }
`;
export const searchMessages = /* GraphQL */ `
  query SearchMessages(
    $filter: SearchableMessageFilterInput
    $sort: SearchableMessageSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchMessages(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        domainId
        topicId
        title
        message
        pinned
        owner
        commentId
        photos {
          url
          mime
        }
        updatedAt
        createdAt
        deleted
        deletedUser
        acl {
          id
          refId
          refIdType
          base {
            create
            read
            update
            delete
            createTopic
            createMessage
            createComment
            createReactions
          }
          guest {
            id
            refId
            refIdType
            create
            read
            update
            delete
            createTopic
            createMessage
            createComment
            createReactions
          }
          items {
            id
            refId
            refIdType
            create
            read
            update
            delete
            createTopic
            createMessage
            createComment
            createReactions
          }
        }
      }
      nextToken
      total
    }
  }
`;
export const searchComments = /* GraphQL */ `
  query SearchComments(
    $filter: SearchableCommentFilterInput
    $sort: SearchableCommentSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchComments(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        domainId
        topicId
        messageId
        message
        photos {
          url
          mime
        }
        owner
        updatedAt
        createdAt
        deleted
        deletedUser
        acl {
          id
          refId
          refIdType
          base {
            create
            read
            update
            delete
            createTopic
            createMessage
            createComment
            createReactions
          }
          guest {
            id
            refId
            refIdType
            create
            read
            update
            delete
            createTopic
            createMessage
            createComment
            createReactions
          }
          items {
            id
            refId
            refIdType
            create
            read
            update
            delete
            createTopic
            createMessage
            createComment
            createReactions
          }
        }
      }
      nextToken
      total
    }
  }
`;
